<template>
  <span>
    {{ descricao }}
  </span>
</template>

<script>

const MEIOS_PAGAMENTOS = {
  '01': 'Dinheiro',
  '02': 'Cheque',
  '03': 'Cartão de Crédito',
  '04': 'Cartão de Débito',
  '05': 'Crédito Loja',
  10: 'Vale Alimentação',
  11: 'Vale Refeição',
  12: 'Vale Presente',
  13: 'Vale Combustível',
  14: 'Duplicata Mercantil',
  15: 'Boleto Bancário',
  16: 'Depósito Bancário / PIX (NF-e mais recentes)',
  17: 'Pagamento Instantâneo (PIX)',
  18: 'Transferência bancária, Carteira Digital',
  19: 'Programa de fidelidade, Cashback, pontos',
  90: 'Sem pagamento (ex.: operação simbólica)',
  99: 'Outros',
};

export default {
  props: {
    meioPagamento: {
      type: String,
      required: true,
    },
  },
  computed: {
    descricao() {
      return MEIOS_PAGAMENTOS[this.meioPagamento] || 'Desconhecido';
    },
  },
};
</script>
